import React from "react";
import { FiExternalLink } from "react-icons/fi";

import { COMPANY } from "config/constants/Company";
import SinapsisLogo from "assets/images/png/sinapsistemas.png";

/**
 * "Desarrollado por Sinapsistemas": indica de quién es el producto Bonsai, con link a la web.
 * El logo va sobre fondo blanco para que su texto azul oscuro se lea también en modo oscuro.
 *
 * @param {boolean} compact Solo el logo chico (menú lateral achicado)
 */
const CompanyCredit = ({ compact: bCompact = false, className: sClassName = "" }) => {
  if (bCompact) {
    return (
      <a
        href={COMPANY.WEB_URL}
        target="_blank"
        rel="noreferrer"
        title={`Desarrollado por ${COMPANY.NAME} - ${COMPANY.WEB_LABEL}`}
        className={`flex justify-center ${sClassName}`}
      >
        <span className="rounded bg-white px-0.5 py-0.5">
          <img src={SinapsisLogo} alt={COMPANY.NAME} className="w-9 h-auto" />
        </span>
      </a>
    );
  }

  return (
    <a
      href={COMPANY.WEB_URL}
      target="_blank"
      rel="noreferrer"
      title={COMPANY.WEB_LABEL}
      className={`group flex flex-col items-center gap-1 rounded-md px-2 py-2 hover:bg-gray-50 dark:hover:bg-gray-800 ${sClassName}`}
    >
      <span className="text-[11px] text-gray-400">Desarrollado por</span>
      <span className="rounded-md bg-white px-2 py-1">
        <img src={SinapsisLogo} alt={COMPANY.NAME} className="h-7 w-auto" />
      </span>
      <span className="flex items-center gap-1 text-[11px] text-gray-500 group-hover:text-primary-600 dark:text-gray-400 dark:group-hover:text-primary-300">
        {COMPANY.WEB_LABEL}
        <FiExternalLink size={11} />
      </span>
    </a>
  );
};

export default CompanyCredit;
